import SectionTab from 'components/common/SectionTab';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

function NewsSectionTab() {
  const { t: ct } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;

  const TabList = [
    {
      key: 'pr',
      path: '/news/pr?page=1',
      text: ct('pr'),
    },
    {
      key: 'announcement',
      path: '/news/announcement?page=1',
      text: ct('ir'),
      disabled: locale === 'en',
    },
  ];

  return <SectionTab tabList={TabList} />;
}

export default NewsSectionTab;
